import ContainerSpace from "../containers/Container";

const MyUHLContainerPage = () => {
    return <ContainerSpace />;
};

export default MyUHLContainerPage;
